function url(path)
{
	return window.BASE_URL + '/' + (path || '').replace(/^\//, '');
}

if (!String.prototype.trim) {
	String.prototype.trim = function () {
		return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	};
}

class App
{
	constructor()
	{
        this.loadXhr = null;
		this.cacheDom();
		this.bindMethods();
		this.bindEvents();
		this.initMiscellaneous();
		this.initCustomerSearch();
	}

	setCookie(cname, cvalue, exdays)
	{
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	getCookie(cname)
	{
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return undefined;
	}

	initMiscellaneous()
	{
		$.ajaxSetup({
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			}
		});

		$('form').each((i, form) => {
			form.reset(); // When page is refreshed, prevent browser from showing old input that wasn't actually submitted.
		});

		$('.show-if-has-error').each((i, element) => {
			if ($('.has-error', element).length) {
				$(element).attr('aria-expanded', 'true').addClass('in');
			}
		});

		$('.click-select-all').each((i, element) => {
			$(element).on('click focus', () => $(element).select());
		});

		$('.has-datetimepicker').datetimepicker({
			sideBySide: true,
			format: 'YYYY-MM-DD HH:mm',
		});

		$('.has-datepicker').datetimepicker({
			format: 'YYYY-MM-DD',
		});

		$('.has-datemonthpicker').datetimepicker({
			viewMode: 'years',
			format: 'YYYY-MM'
		});

		$('.has-dateyearpicker').datetimepicker({
			viewMode: 'years',
			format: 'YYYY'
		});

		$('.has-datepicker-format').datetimepicker({
			format: 'DD/MM/YY'
		});

		$('[data-toggle=popover]').popover();
		$('[data-toggle=tooltip]').tooltip();

		$('.confirmed').click((event) => {
			return confirm($(event.target).data('confirm'));
		});

		$('#toggle-yes-no').bootstrapToggle({
			on: 'Yes',
			off: 'No'
		});

		$('.toggle-yes-no').bootstrapToggle({
			on: 'Yes',
			off: 'No'
		});

		$(document).ajaxComplete(function() {
			$('[data-toggle=popover]').popover();
			$('[data-toggle=tooltip]').tooltip();
		})
	}

	showCustomerAutocomplete(event)
	{
		$(event.target).autocomplete('search');
	}

	initCustomerSearch()
	{
		this.$customerFields.each((i, field) => {
			const $field = $(field);
			$field.autocomplete({
				source: Data.sales.customers,
				minLength: 0,
				classes: {
					'ui-autocomplete': 'customer-autocomplete',
				},
				select: (event, ui) => {
					$field.trigger('customer.selected', [ui.item.value, ui.item.label])
					return false;
				},
				focus: (event, ui) => {
					return false;
				},
			});
		});
	}

	/**
	 * Basic error handler that can be used in $.ajax if you don't expect any specific errors.
	 */
	ajaxError(res)
	{
		alert("An error occurred. Please contact tech support.");
	}

	universalSearch(event, orderCol = '', orderDir = '')
	{
		console.log('universal search');
		var formData = this.$universalSearchForm.serialize();
		var target = $(event.target);

		if (event.oldDate === null) {
		    console.log('returning false - do not want ajax on page load');
		    return false;
        }

        if (this.loadXhr) this.loadXhr.abort();

		var spinner = "<div class='universal-spinner'></div>";

		if(this.$universalSearchForm.hasClass('spinner')) {
			this.$universalTableWrapper.prepend(spinner)
		}

        this.loadXhr = $.ajax(CURRENT_URL, {
			data: formData,
			success: (res) => {
				this.$universalTableWrapper.html(res.itemsHtml);
				this.$universalPaginationWrapper.html(res.paginationHtml);
				return this.universalSearchSortUpdateColumns(orderCol, orderDir);
			}
		})
	}

	universalSearchSort(event, search = true) {
		var target = $(event.target);
		console.log('universal search sort');
		var orderCol = '';
		var orderDir = '';
		if(target.data('column-name')) {
			var form = target.parents().find('#universal-search-form');
			var inputOrderCol = $('[name=order_col]', form);
			var inputOrderDir = $('[name=order_dir]', form);
			//console.log(target);
			//console.log(target.children('.universal-search-sort-order'));
			//console.log(target.closest().find('.universal-search-sort-order'));
			//console.log(target.find('.universal-search-sort-order').closest());
			if(!target.children('.universal-search-sort-order').length) {
				target.append(" <i class='fa fa-sort-desc universal-search-sort-order'></i>");
				target.data('column-order', 'desc');
				orderCol = target.data('column-name');
				orderDir = 'desc';
				inputOrderCol.val(target.data('column-name'));
				inputOrderDir.val('desc');
			} else if(target.children('.universal-search-sort-order').length && target.data('column-order') === 'desc') {
				target.find('.universal-search-sort-order').remove();
				target.append(" <i class='fa fa-sort-asc universal-search-sort-order'></i>");
				target.data('column-order', 'asc');
				orderCol = target.data('column-name');
				orderDir = 'asc';
				inputOrderCol.val(target.data('column-name'));
				inputOrderDir.val('asc');
			} else {
				target.children('.universal-search-sort-order').remove();
				target.data('column-order', '');
				inputOrderCol.val('');
				inputOrderDir.val('');
			}
		}

		return this.universalSearch(event, orderCol, orderDir);
	}

	universalSearchSortUpdateColumns(column = '', dir = '') {
		console.log("update search sort column s" + column + " " + dir);
		if(column) {
			var elCol = $('.universal-search-sort-column[data-column-name="' + column + '"]');
			//console.log(elCol);
			if (dir === 'desc') {
				elCol.append(" <i class='fa fa-sort-desc universal-search-sort-order'></i>");
				elCol.data('column-order', 'desc');
			} else if (dir === 'asc') {
				elCol.append(" <i class='fa fa-sort-asc universal-search-sort-order'></i>");
				elCol.data('column-order', 'asc');
			} else {
				elCol.data('column-order', '');
			}

		}
		this.cacheDomDynamic();
		this.bindEventsDynamic();
	}

	universalSort(event)
	{
		var field = $(event.target);
		var sort = field.data('name');
		var sortO = "DESC";
        if(field.find('i').hasClass('fa-caret-down')) {
            field.find('i.fa-caret-down').remove();
            field.append(" <i class='fa fa-caret-up'></i>")
            sortO = 'ASC';
        } else if(field.find('i').hasClass('fa-caret-up')) {
            field.find('i.fa-caret-up').remove();
            sortO = '';
            sort = '';
        } else {
            field.append(" <i class='fa fa-caret-down'></i>")
		}

		console.log(sort + " " + sortO);

        if (this.loadXhr) this.loadXhr.abort();

        this.loadXhr = $.ajax(CURRENT_URL, {
            data: { sort: sort, sortO: sortO},
            success: (res) => {
				this.$universalSortResult.html(res.resultHtml);
            }
        })

	}

	cacheDom()
	{
		this.$customerFields = $('.customer-field');
		this.$messagesJs = $('#messages-js');
		this.$universalSearchForm = $('#universal-search-form');
		this.$universalTableWrapper = $('#universal-table-wrapper');
		this.$universalPaginationWrapper = $('#universal-pagination-wrapper');
		this.$universalSortRow = $('#universal-sort-row');
		this.$universalSortColumn = $('.sort-column', this. $universalSortRow);
		this.$universalSortResult = $('#universal-sort-result');
		this.cacheDomDynamic();
	}

	cacheDomDynamic()
	{
		this.$universalSearchSortColumn = $('.universal-search-sort-column');
	}

	bindMethods()
	{
		this.ajaxError = this.ajaxError.bind(this);
		this.initCustomerSearch = this.initCustomerSearch.bind(this);
		this.showCustomerAutocomplete = this.showCustomerAutocomplete.bind(this);
		this.universalSearch = this.universalSearch.bind(this);
		this.universalSearchSort = this.universalSearchSort.bind(this);
		this.universalSort = this.universalSort.bind(this);
	}

	bindEvents()
	{
		this.$customerFields.click(this.showCustomerAutocomplete);
		this.$universalSearchForm.submit(() => false);
		this.$universalSearchForm.on('change keyup submit dp.change', this.universalSearch);
		this.$universalSortColumn.click(this.universalSort);
		this.bindEventsDynamic();
	}

	bindEventsDynamic()
	{
		this.$universalSearchSortColumn.click(this.universalSearchSort);
	}
}

const APP = new App;
APP.users = new Users;
APP.auth = new Auth;
APP.home = new Home;
APP.tradeIns = new TradeIns;